require('../../modules/es6.number.parse-int');
module.exports = parseInt;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/number/parse-int.js
// module id = 120
// module chunks = 0